export default __webpack_public_path__ + "images/LB.27b6cba.png";